import gql from 'graphql-tag';

export default gql`
  subscription reportNotification($networkID: String) {
    notification: reportNotification(networkID: $networkID) {
      data
    }
  }
`;
